module.exports = __webpack_public_path__ + "media/img/lifetime-ui-7bef2aee8c49881b9d6d674ad0a84d74.svg";